import {
  KeyOutlined,
  LockOutlined,
  Visibility,
  VisibilityOff
} from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { CHANGE_PASSWORD, VERIFY_TOKEN } from "../Config/Config";
import Constant from "../services/Constant";
import ForgotPassowrdTokenExpired from "./ForgotPassowrdTokenExpired";
import PasswordChanged from "./PasswordChanged";
const ForgotPassword = () => {
  const { fp_token } = useParams();
  const [IsLoadning, setIsLoadning] = useState(true);
  const [IsVerify, setIsVerify] = useState(false);
  const getData = async () => {
    const { data } = await VERIFY_TOKEN(fp_token);
    if (data.s)
    {
      setIsLoadning(false);
      setIsVerify(true);
    } else
    {
      setIsLoadning(false);
      setIsVerify(false);
    }
  };

  useEffect(() => {
    getData();
  }, [fp_token]);
  return (
    <>
      {IsLoadning ? (
        <Box sx={{ background: Constant.COLOR_PALLETE.background.gd, height: "100vh", width: "100vw", display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
          <Container
            maxWidth="sm"
            sx={{
              display: "flex",
              boxShadow: 12,
              borderRadius: 5,
              overflow: "hidden",
              bgcolor: "background.paper",
              p: 4,
              py: 10,
              gap: 2,
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              animation: "pop 3s cubic-bezier(.68,-0.55,.27,1.55) 1",
              "@keyframes pop": {
                "0%": { transform: "scale(0.97)" },
                "50%": { transform: "scale(1.03)" },
                "100%": { transform: "scale(1)" },
              },
            }}
          >
            <Box sx={{ mb: 3, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src={"/logo.png"} alt="" style={{ width: "100px", height: "auto" }} />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2, flexDirection: "column" }}>
              <CircularProgress sx={{
                zIndex: 9999999999,
                color: Constant.COLOR_PALLETE.background.primary,
                width: "100px",
                height: "100px",
              }} />
              <Typography variant="h6" fontWeight={800} textAlign="center" color="GrayText" sx={{
                fontFamily: 'DM Sans',
              }}>
                Verifying your token...
              </Typography>
            </Box>
          </Container>
        </Box>
      ) : IsVerify ? (
        <InputField />
      ) : (
        <ForgotPassowrdTokenExpired />
   
      )}
    </>
  );
};
export default ForgotPassword;
const InputField = () => {
  const theme = useTheme();
  const { fp_token } = useParams();
  const [isChanged, setIsChanged] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const toggleShowNewPassword = () => setShowNewPassword((show) => !show);
  const toggleShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
      confirmPassword: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try
      {
        const { data } = await CHANGE_PASSWORD({
          fp_token: fp_token,
          password: values.newPassword,
        });
        if (data?.s)
        {
          setIsChanged(true);
          resetForm();
        }
      } catch (error)
      {
        console.log("error", error);
      }
    },
  });
  if (isChanged)
  {
    return <PasswordChanged />;
  }
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: Constant.COLOR_PALLETE.background.gd,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: { xs: 2, md: 2 },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          boxShadow: 12,
          width: { xs: "100%", sm: "75%", md: "auto" },
          borderRadius: { xs: 3, md: 5 },
          overflow: "hidden",
          bgcolor: "background.paper",
          animation: "pop 3s cubic-bezier(.68,-0.55,.27,1.55) 1",
          "@keyframes pop": {
            "0%": { transform: "scale(0.97)" },
            "50%": { transform: "scale(1.03)" },
            "100%": { transform: "scale(1)" },
          },
        }}
      >
        <Box
          sx={{
            flex: { xs: "none", lg: 1 },
            bgcolor: "rgba(8,85,127,0.02)",
            backgroundImage:
              Constant.COLOR_PALLETE.background.gd,
            p: { xs: 3, md: 4, lg: 6 },
            position: "relative",
            display: { xs: "none", lg: "flex" },
            alignItems: "center",
            justifyContent: "center",
            minHeight: { xs: "200px", md: "auto" },

          }}
        >
          {/* Blurred circles */}
          <Box
            sx={{
              position: "absolute",
              width: 288,
              height: 288,
              bgcolor: "rgba(255,179,0,0.07)",
              borderRadius: "50%",
              filter: "blur(48px)",
              top: 0,
              left: 0,
              zIndex: 1,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              width: 240,
              height: 240,
              bgcolor: "rgba(0,151,178,0.06)",
              borderRadius: "50%",
              filter: "blur(48px)",
              bottom: 0,
              right: 0,
              zIndex: 1,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              width: 80,
              height: 80,
              bgcolor: "rgba(255,179,0,0.13)",
              borderRadius: "50%",
              filter: "blur(24px)",
              left: 64,
              bottom: "33%",
              zIndex: 1,
            }}
          />
          <img
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/79a7504dd5-797fe0410d6f955dd568.png"
            alt="2d modern illustration, person holding a big secure padlock and password input"
            style={{
              maxWidth: "320px",
              height: "auto",
              position: "relative",
              animation: "float 6s ease-in-out infinite",
              borderRadius: "16px",
              zIndex: 2,
            }}
          />
          <style>{`
              @keyframes float {
                0% { transform: translateY(0px); }
                50% { transform: translateY(-20px); }
                100% { transform: translateY(0px); }
              }
            `}</style>
        </Box>
        <Box
          sx={{
            flex: 1,
            p: { xs: 3, sm: 4, md: 6, lg: 8 },
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: { xs: 16, md: 24 },
              right: { xs: 16, md: 28 },
              bgcolor: Constant.COLOR_PALLETE.background.primary,
              backgroundImage: Constant.COLOR_PALLETE.background.primary,
              color: Constant.COLOR_PALLETE.white,
              px: { xs: 2, md: 3 },
              py: 0.5,
              borderRadius: 20,
              fontSize: { xs: 10, md: 12 },
              fontWeight: 600,
              display: { xs: "none", sm: "inline-flex" },
              alignItems: "center",
              gap: 1,
              boxShadow: 1,
            }}
          >
            <LockOutlined
              sx={{
                color: Constant.COLOR_PALLETE.white
              }}
              fontSize="small"
            />
            Secure Reset
          </Box>
          <Box sx={{ mb: { xs: 2, md: 3 } }}>
            <img src={"/logo.png"} alt="" style={{ width: "auto", height: "auto", maxWidth: "100%" }} />
          </Box>
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              formik.handleSubmit();
              return false;
            }}
            noValidate
            sx={{ display: "flex", flexDirection: "column", gap: { xs: 3, md: 4 } }}
          >
            <Box sx={{ mb: { xs: 3, md: 5 } }}>
              <Typography variant="h3" fontWeight={800} gutterBottom sx={{ fontSize: { xs: "1.75rem", sm: "2.125rem", md: "3rem" } }}>
                Reset Your Password
              </Typography>
              <Typography color="text.secondary" sx={{ maxWidth: { xs: "100%", md: 400 }, fontSize: { xs: "0.875rem", md: "1rem" } }}>
                Choose a strong new password for your account. Enter and confirm
                your new password below to securely update your credentials.
              </Typography>
            </Box>
            <FormControl variant="outlined" required fullWidth>
              <InputLabel htmlFor="new-password">New Password</InputLabel>
              <OutlinedInput
                name="newPassword"
                type={showNewPassword ? "text" : "password"}
                onBlur={formik.handleBlur}
                value={formik.values.newPassword}
                onKeyUp={formik.handleBlur}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value.trimStart() !== value)
                  {
                    e.target.value = value.trimStart();
                  }
                  formik.handleChange(e);
                }}
                label="New Password"
                inputProps={{
                  minLength: 8,
                  placeholder: "Enter new password",
                  autoComplete: "new-password",
                }}
                sx={{
                  borderRadius: "10px",
                  fontSize: { xs: "0.875rem", md: "1rem" },
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle new password visibility"
                      onClick={toggleShowNewPassword}
                      edge="end"
                      size="large"
                    >
                      {showNewPassword ? <VisibilityOff style={{ color: Constant.COLOR_PALLETE.background.primary }} /> : <Visibility style={{ color: Constant.COLOR_PALLETE.background.primary }} />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {formik.touched.newPassword && formik.errors.newPassword ? (
                <FormHelperText
                  sx={{
                    color: "red",
                  }}
                >
                  {formik.errors.newPassword}
                </FormHelperText>
              ) : null}
            </FormControl>
            {/* Confirm Password */}
            <FormControl variant="outlined" required fullWidth>
              <InputLabel htmlFor="confirm-password">
                Confirm Password
              </InputLabel>
              <OutlinedInput
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
                onKeyUp={formik.handleBlur}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value.trimStart() !== value)
                  {
                    e.target.value = value.trimStart();
                  }
                  formik.handleChange(e);
                }}
                sx={{
                  borderRadius: "10px",
                  fontSize: { xs: "0.875rem", md: "1rem" },
                }}
                label="Confirm Password"
                inputProps={{
                  minLength: 8,
                  placeholder: "Re-enter new password",
                  autoComplete: "new-password",
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle confirm password visibility"
                      onClick={toggleShowConfirmPassword}
                      edge="end"
                      size="large"
                    >
                      {showConfirmPassword ? <VisibilityOff style={{ color: Constant.COLOR_PALLETE.background.primary }} /> : <Visibility style={{ color: Constant.COLOR_PALLETE.background.primary }} />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                <FormHelperText
                  sx={{
                    color: "red",
                  }}
                >
                  {formik.errors.confirmPassword}
                </FormHelperText>
              ) : null}
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                background:
                  Constant.COLOR_PALLETE.background.primary,
                py: { xs: 1, md: 1.5 },
                fontWeight: 600,
                fontSize: { xs: "0.875rem", sm: "1rem", md: "1.125rem" },
                boxShadow: 6,
                borderRadius: "10px",
                "&:hover": {
                  boxShadow: 12,
                  background:
                    Constant.COLOR_PALLETE.background.primary,
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
              }}
            >
              <KeyOutlined
                fontSize="medium"
                sx={{
                  transition: "transform 0.3s",
                  "&:hover": { transform: "rotate(12deg)" },
                }}
              />
              Reset Password
            </Button>
          </Box>
        </Box>
      </Container >
    </Box >
  );
};
